import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const WorkflowInsights = ({ insights, loading }) => {
  if (loading) {
    return (
      <div className="glass-card p-6 rounded-2xl">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            <div className="h-20 bg-gray-100 rounded"></div>
            <div className="h-20 bg-gray-100 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  const statusData = [
    { name: 'Nouveau', value: insights?.statusDistribution?.new || 0, color: '#3b82f6' },
    { name: 'En revue', value: insights?.statusDistribution?.reviewed || 0, color: '#f59e0b' },
    { name: 'Programmé', value: insights?.statusDistribution?.scheduled || 0, color: '#8b5cf6' },
    { name: 'Terminé', value: insights?.statusDistribution?.completed || 0, color: '#10b981' },
    { name: 'Annulé', value: insights?.statusDistribution?.cancelled || 0, color: '#ef4444' }
  ];

  const kpiCards = [
    {
      title: 'Taux de finalisation',
      value: `${Math.round(insights?.completionRate || 0)}%`,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      description: 'Cas terminés avec succès'
    },
    {
      title: 'Taux d\'annulation',
      value: `${Math.round(insights?.cancellationRate || 0)}%`,
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      description: 'Cas annulés'
    },
    {
      title: 'Délai moyen',
      value: `${Math.round(insights?.avgDaysToComplete || 0)}j`,
      icon: 'Clock',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      description: 'De soumission à finalisation'
    },
    {
      title: 'Total traité',
      value: insights?.totalReferrals || 0,
      icon: 'FileText',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      description: 'Sur les 30 derniers jours'
    }
  ];

  return (
    <div className="glass-card p-6 rounded-2xl">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center">
          <Icon name="BarChart" size={20} className="text-accent" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Aperçu du workflow</h3>
          <p className="text-sm text-muted-foreground">Indicateurs clés de performance</p>
        </div>
      </div>
      {/* KPI Cards */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        {kpiCards?.map((card, index) => (
          <div key={index} className="p-4 bg-gray-50 rounded-xl">
            <div className="flex items-center gap-3 mb-2">
              <div className={`w-8 h-8 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
                <Icon name={card?.icon} size={16} className={card?.color} />
              </div>
              <div className="flex-1">
                <p className="text-xs text-muted-foreground">{card?.title}</p>
                <p className="text-2xl font-bold text-foreground">{card?.value}</p>
              </div>
            </div>
            <p className="text-xs text-muted-foreground">{card?.description}</p>
          </div>
        ))}
      </div>
      {/* Status Distribution */}
      <div className="pt-6 border-t border-gray-200">
        <h4 className="text-sm font-semibold text-foreground mb-4">Distribution par statut</h4>
        <div className="flex items-center gap-6">
          <ResponsiveContainer width="40%" height={160}>
            <PieChart>
              <Pie
                data={statusData}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={70}
                paddingAngle={3}
                dataKey="value"
              >
                {statusData?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry?.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
          <div className="flex-1 space-y-2">
            {statusData?.map((item, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: item?.color }}></div>
                  <span className="text-sm text-muted-foreground">{item?.name}</span>
                </div>
                <span className="text-sm font-semibold text-foreground">{item?.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowInsights;